module.exports = {"component":"spinner","status":"prod","display-name":"Spinners","SLDS-component-path":"/components/spinner"}


//////////////////
// WEBPACK FOOTER
// ./components/spinner/docs.json
// module id = 222
// module chunks = 0